<template>
  <div class="percentage-circle-wrapper">
    <svg viewBox="0 0 36 36" class="circular-chart orange">
      <path class="circle-bg"
        d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
      />
      <path class="circle"
        :stroke-dasharray="`${ value }, 100`"
        d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
      />
      <text x="18" y="20.35" class="percentage">{{ text }}</text>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'percentage-circle',
  props: {
    value: {
      type: [ Number, String ],
      default: 100
    },

    text: {
      type: [ Number, String ],
      default: ''
    }
  },
};
</script>

<style lang="scss">
.percentage-circle-wrapper {
  width: 100%;
  height: auto;

  svg {
    width: 100%;
    height: auto;
  }

  .circular-chart {
    display: block;
    margin: 10px auto;
    max-width: 80%;
    max-height: 250px;
  }

  .circle-bg {
    fill: none;
    stroke: #eee;
    stroke-width: 2;
  }

  .circle {
    fill: none;
    stroke-width: 2;
    stroke-linecap: round;
    animation: progress 1s ease-out forwards;
  }

  @keyframes progress {
    0% {
      stroke-dasharray: 0 100;
    }
  }

  .circular-chart.orange .circle {
    stroke: #ff9f00;
  }

  .percentage {
    fill: #fff;
    font-family: sans-serif;
    font-size: 6px;
    text-anchor: middle;
  }
}
</style>
